import React from "react";
import Main from "./components/Main";

const App = () => {
  return (
    <div className="container">
      <Main />
    </div>
  );
};

export default App;
